module.exports = __webpack_public_path__ + "img/thumbnail-sea-walk.fa2e0422.jpg";